var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './CustomRanges.module.scss';
import { v4 as uuid } from 'uuid';
import { CheckmarkGreen } from '../../../../assets/icons';
import { CUSTOM_RANGES, getActiveRange } from '../../../../services';
var CustomRanges = function (_a) {
    var onChange = _a.onChange, startDate = _a.startDate, compareOn = _a.compareOn, endDate = _a.endDate;
    var _b = useState(), active = _b[0], setActive = _b[1];
    useEffect(function () {
        setActive(getActiveRange(startDate, endDate));
    }, [startDate, endDate]);
    var isRangeActive = function (range) { return range.label === (active === null || active === void 0 ? void 0 : active.label); };
    var onRangeChange = function (dates) {
        var start = dates.start, end = dates.end;
        !compareOn && onChange(start, start, end);
    };
    var renderCustomRanges = function () {
        return CUSTOM_RANGES.map(function (r) { return (_jsxs("li", __assign({ className: "".concat(styles.Range, " ").concat(isRangeActive(r) ? styles.Active : '', " ").concat(compareOn ? styles.Disabled : ''), onClick: function () { return onRangeChange(r.setter()); } }, { children: [r.label, isRangeActive(r) && _jsx(CheckmarkGreen, {})] }), uuid())); });
    };
    return _jsx("ul", __assign({ className: styles.CustomRanges }, { children: renderCustomRanges() }));
};
CustomRanges.propTypes = {
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    compareOn: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};
export { CustomRanges };
//# sourceMappingURL=CustomRanges.js.map